import contentfulGql from 'js/lib/contentfulGql';

import { entWebsiteBlockAssemblyFragment } from 'bundles/ent-website/queries/EntWebsiteBlockAssembly';
import { entWebsiteTestimonialFragment } from 'bundles/ent-website/queries/EntWebsiteTestimonial';

export const entWebsiteTestimonialCarouselFragment = contentfulGql`#graphql
  ${entWebsiteTestimonialFragment}
  fragment EntWebsiteTestimonialCarousel on EntWebsiteTestimonialCarousel {
    slug
    testimonialsCollection {
      items {
        ...EntWebsiteTestimonial
      }
    }
  }
`;

export const entWebsiteBlockTestimonialCarouselQuery = contentfulGql`#graphql
  ${entWebsiteBlockAssemblyFragment}
  ${entWebsiteTestimonialCarouselFragment}
  query entWebsiteBlockTestimonialCarousel($id: String!, $preview: Boolean, $locale: String!) {
    entWebsiteBlockAssembly(id: $id, preview: $preview, locale: $locale) {
      ...EntWebsiteBlockAssembly
      reference {
        __typename
        ...EntWebsiteTestimonialCarousel
      }
    }
  }
`;
